// test599
(599 && 0);
